import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useThreadApi } from "../../Services/ThreadApiProvider";
import ChatLoader from "./Loader";
import Button from "../Buttons";
import ThreadItem from "./ThreadItem";

const ChatsSidebar = () => {
    const { organizationId, chatId } = useParams();
    const navigate = useNavigate();

    const {
        isOnline,
        loading,
        threads,
        totalThreads,
        haveMoreThreads,
        setThreadType,
        threadType,
        setThreadSkip,
        threadLimit,
        searchValue,
        setSearchValue,
        handleKeyDown,

    } = useThreadApi();

    const handleInputChange = (e) => {
      setSearchValue(e.target.value);
    };

    useEffect(() => {
        if (!chatId && threads && threads.length > 0) {
            navigate(`/organizations/${organizationId}/chats/${threads[0].id}`);
            return;
        }
        
        if (chatId && threads && threads.length > 0 && !threads.some(thread => thread.id === chatId)) {
            return;
        }
    }, [chatId, threads]);

    const onTabClick = (tabName) => {
        setThreadSkip(0);
        setThreadType(tabName);
    }

    return (
        <div className="chats-sidebar d-flex flex-column">
            <div className="sidebar-header">
                <div className="toolbar">
                    <div className="title-unread">
                        <div className="title">Чати</div>
                        <div className="unread">{totalThreads}</div>
                        {isOnline && (<div><i className="fa-solid fa-globe"></i></div>)}
                    </div>
                </div>
                <div className="search">
                    <div className="search-wrapper">
                        <div className="icon-wrapper">
                            <i className="fa-solid fa-magnifying-glass"></i>
                        </div>
                        <input
                            className="search-input"
                            type="text"
                            value={searchValue}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            placeholder="Пошук повідомлень..."
                        />
                    </div>
                </div>
                <div className="tabs">
                    <button
                        className={`tab opened ${threadType === "active" ? "active" : ""}`}
                        onClick={() => onTabClick("active")}
                    >
                        Активні
                    </button>
                    <button
                        className={`tab closed ${threadType === "inactive" ? "active" : ""}`}
                        onClick={() => onTabClick("inactive")}
                    >
                        Закриті
                    </button>
                    <button
                        className={`tab all ${threadType === "all" ? "active" : ""}`}
                        onClick={() => onTabClick("all")}
                    >
                        Всі
                    </button>
                </div>
            </div>
            <div className="chats-list">
                {loading && (<ChatLoader style={{width: '100%', height: '100%'}}/>)}
                {!loading && (
                    <>
                        {threads.length === 0 && (
                            <div className="no-chats">
                                <span className="no-chats-title">Схоже нічого немає, але треба ще пошукати</span>
                                <span className="no-chats-image"></span>
                            </div>
                        )}
                      
                      {threads.map(element =>
                        <ThreadItem
                            key={element.id}
                            thread={element}
                        />
                      )}

                      {haveMoreThreads && (
                          <div className="tabs d-flex justify-center">
                              <Button
                                  variant="primary" 
                                  size="small"
                                  style={{ margin: "0 auto", width: "100%", flexDirection: "row", justifyContent: "center" }}
                                  onClick={async () => setThreadSkip(prev => prev + threadLimit)}
                              >
                                  Завантажити ще
                              </Button>
                          </div>
                      )}
                  </>
              )}
            </div>
        </div>
    );
};

export default ChatsSidebar;